import { default as ServicesUtils } from '../services/services.Utils.js';
import { default as ServicesFindAndBook } from '../services/services.FindAndBook.js';
import { default as ServicesLogout } from '../services/services.Logout.js';
import { default as ServicesPmf } from '../services/services.Pmf.js';
import { default as ServicesStats } from '../services/services.Stats.js';
import { default as ServicesAcademy } from '../services/services.Academy.js';

export default class Services {

    static get Base() { return ServicesUtils; }

    static get FindAndBook() { return ServicesFindAndBook; }

    static get Logout() { return ServicesLogout; }

    static get Pmf() { return ServicesPmf; }

    static get Stats() { return ServicesStats; }

    static get Academy() { return ServicesAcademy; }
}
